import AppEvent from '../../../../../../../foundation/events/AppEvent';
import EntityId from '../../../../../../../foundation/domain/EntityId';
import User from '../User';

abstract class UserEvent implements AppEvent {

	public constructor (private userId: EntityId<User>) {
	}

	public getUserId () {
		return this.userId;
	}
}

export default UserEvent;


// WEBPACK FOOTER //
// ./code/project/modules/users/domain/aggregates/user/events/UserEvent.ts